
import { api_host,api_auth} from '../../common/globals/constants';

export const getRegistersPlus = (objective, node, token, date, user) => 
fetch(api_host+`/reporte/general/objetivos/${objective}/registro_plus/?token=${token}&t=h&node=${node}&date=${date}&user=${user}`)
.then(response => response.json())
